import styled, { css } from "styled-components";

const breakPoint = "@media (min-width: 600px)";
const breakPoint2 = "@media (min-width: 678px)";

export const Subtitle = styled.h3`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 10px;
`;

export const Flex = styled.div`
  margin-bottom: 20px;
  ${breakPoint} {
    display: flex;
    flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  }
`;

const copyLeftStyles = css`
  padding-right: 40px;
`;
const copyRightStyles = css`
  padding-left: 40px;
`;

export const Copy = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  ${breakPoint} {
    ${(props) => props.left && copyLeftStyles};
    ${(props) => props.right && copyRightStyles};
  }
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;
  ${breakPoint2} {
    width: auto;
  }
  & img {
    display: block;
    margin: auto;
  }
`;
